// Pure helpers for locking drag and drop of agenda items. No imports - the file is also loaded without a bundler in tests.

const STORAGE_KEY_PREFIX = "agenda-drag-lock-";

function hasLid(lid) {
    return lid !== null && lid !== undefined;
}

function applyDisabled(draggable, disabled) {
    if (draggable === null || draggable === undefined) {
        return;
    }

    try {
        // the type check is inside the try as well - reading updateOptions of a foreign object may throw
        if (typeof draggable.updateOptions === "function") {
            draggable.updateOptions({ disabled: disabled });
        }
    } catch (e) {
        // one failing list must not stop the others
    }
}

// vue-draggable-next 2.3.0 reads the "disabled" attribute only when the list is created,
// so every later change has to be pushed to the live Sortable through updateOptions.
// Accepts a single draggable or an array of them (one nested level, as refs inside v-for are arrays).
export function syncDraggableDisabled(draggables, disabled) {
    const isDisabled = Boolean(disabled);
    const targets = Array.isArray(draggables) ? draggables : [draggables];

    for (const target of targets) {
        if (Array.isArray(target)) {
            for (const nested of target) {
                applyDisabled(nested, isDisabled);
            }
        } else {
            applyDisabled(target, isDisabled);
        }
    }
}

export function isAgendaDragLockActive(lockSetting, isInteractiveMode, isTemplate) {
    return lockSetting === true && isInteractiveMode === true && isTemplate !== true;
}

export function getAgendaDragLockStorageKey(lid) {
    return `${STORAGE_KEY_PREFIX}${lid}`;
}

export function readAgendaDragLock(storage, lid) {
    if (!hasLid(lid)) {
        return false;
    }

    try {
        const value = storage.getItem(getAgendaDragLockStorageKey(lid));
        return value === true || value === "true";
    } catch (e) {
        return false;
    }
}

export function saveAgendaDragLock(storage, lid, value) {
    if (!hasLid(lid)) {
        return;
    }

    try {
        storage.setItem(getAgendaDragLockStorageKey(lid), Boolean(value));
    } catch (e) {
        // the choice is only remembered on a best-effort basis
    }
}
